
<template>
  <div>
    <div v-if="routeText">
      <p v-html="routeText"></p>
    </div>
    <div v-else>
      <p>{{ $t('base.errors.unauthorized.message360') }}</p>
    </div>
    <div>
        <base-button @click="goToSignInOpensalud">{{ $t('base.errors.unauthorized-360-error-page.go-to-opensalud') }}</base-button>
      </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton
  },
  methods: {
    goToSignInOpensalud () {
      window.location.href = this.$helpers.getV2AppUrl('inicio-sesion')
    }
  },
  computed: {
    routeText () {
      return this.$store.state.errorPageMessage
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/errors/Unauthorized360AccessErrorPage.vue